import { COUNTY_FIELD } from "../config/stepper-form";

export const CREATE_FORM_OBJ = "CREATE_FORM_OBJ";
export const CHANGE_EVENT = "CHANGE_EVENT";
export const CHECK_FORM = "CHECK_FORM";
export const CHECK_PHONE_STATUS = "CHECK_PHONE_STATUS";

export const COUNTRY_CHANGE = "COUNTRY_CHANGE";
export const GOOGLE_ADDRESS = "GOOGLE_ADDRESS";

export const ONBOARD_STATUS = "ONBOARD_STATUS";
export const ONBOARD_ERROR = "ONBOARD_ERROR";
export const ONBOARD_ERROR_CLOSE = "ONBOARD_ERROR_CLOSE";

export const GET_FIELDS = "GET_FIELDS";
export const UPDATE_COUNTY_FIELD = "UPDATE_COUNTY_FIELD";
export const UPDATE_OPTIONS_TO_FIELDS = "UPDATE_OPTIONS_TO_FIELDS";
export const RESET_FORM_FIELDS = "RESET_FORM_FIELDS";
export const RESET_FIELD_OPTIONS = "RESET_FIELD_OPTIONS";

export const ORG_CREATE_TRIGGERED = "ORG_CREATE_TRIGGERED";
export const ONBOARD_ALERT = "ONBOARD_ALERT";

export const markCountyFieldAsRequired = () => ({
  type: UPDATE_COUNTY_FIELD,
  payload: { name: COUNTY_FIELD.name, required: true },
});

export const markCountyFieldAsOptionsal = () => ({
  type: UPDATE_COUNTY_FIELD,
  payload: { name: COUNTY_FIELD.name, required: false },
});

export const changeEvent = (valObj = {}) => ({
  type: CHANGE_EVENT,
  payload: valObj,
});

export const checkFormValidity = () => ({
  type: CHECK_FORM,
});

export const countryChange = payload => ({
  type: COUNTRY_CHANGE,
  payload,
});

export const googleAddressUpdate = payload => ({
  type: GOOGLE_ADDRESS,
  payload,
});

export const updateOptions = payload => ({
  type: UPDATE_OPTIONS_TO_FIELDS,
  payload,
});

export const resetFormFields = payload => ({
  type: RESET_FORM_FIELDS,
  payload
});

export const resetFieldOptions = payload => ({
  type: RESET_FIELD_OPTIONS,
  payload
});